import axios from "@/plugins/axios";
import store from "@/store";
import { de } from "date-fns/locale";


export default {
    getReports(pagination) {
        let params = {}
        params.page = pagination.page;
        params.limit =
            pagination.rowsPerPage == -1 ? 9999 : pagination.rowsPerPage;
        if (pagination.sortBy)
            params.order =
            (pagination.descending ? "-" : "") + pagination.sortBy;

        return axios.httpApi.get("reports", { params });
    },
    getReport(id) {
        return axios.httpApi.get("reports/" + id);
    },
    getStatusTask(task) {
        return axios.httpApi.get("task/" + task);
    },
    getFile(id) {
        return axios.httpApi.get("files/" + id + "/download");
    },
    generateReport(type, firing_ids = [], creditor_ids = [], publics = [], approachTypes = [], status = [], only_auto = [], start_date = null, end_date = null, gateways = []) {
        let currentUser = store.getters.getLoggedUser
        let params = { type }

        params['user_name'] = currentUser.name
        if (firing_ids.length) params['firing_ids'] = firing_ids
        if (creditor_ids.length) params['creditor_ids'] = creditor_ids
        if (publics.length) params['publics'] = publics
        if (approachTypes.length) {
            params['approach_types'] = approachTypes
        }

        if (only_auto.length == 0 || only_auto.length > 1) params['only_auto'] = null
        else if (only_auto.includes('true')) params['only_auto'] = true
        else params['only_auto'] = false

        if (status.includes('accessed')) params['accessed'] = true
        if (status.includes('localized')) params['localized'] = true
        if (status.includes('proposalConfirmed')) params['proposal_confirmed'] = true
        if (status.includes('proposalAgreed')) params['proposal_agreed'] = true

        if (start_date) params['firing_date_ini'] = start_date
        if (end_date) params['firing_date_end'] = end_date

        if (gateways.length) params['gateways'] = gateways
        
        return axios.httpApi.post("reports", {
            type,
            params
        });
    }
};